import { CmsObjectWithDefault } from '@components/Cms/types';

export type ForceLogoutFormCmsKey =
    | 'Title'
    | 'Confirmation'
    | 'ConfirmationDescription'
    | 'YesProceed'
    | 'Cancel'
    | 'TechnicalDifficulty';

export const ForceLogoutFormCmsWithDefault: CmsObjectWithDefault<ForceLogoutFormCmsKey> = {
    Title: {
        cmsId: 355589,
        defaultTranslation: 'Sign out from all devices',
    },
    Confirmation: {
        cmsId: 355590,
        defaultTranslation: 'You are about to sign out of all devices',
    },
    ConfirmationDescription: {
        cmsId: 355591,
        defaultTranslation:
            'This action will log you out of all devices, and you’ll need to sign in again on each one individually if you wish to access your account. Do you want to continue?',
    },
    YesProceed: {
        cmsId: 355592,
        defaultTranslation: 'Yes, Proceed',
    },
    Cancel: {
        cmsId: 355593,
        defaultTranslation: 'Cancel',
    },
    TechnicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
};
